import { Controller } from '@hotwired/stimulus'

// Flowbite の Drawer（data-drawer-*）を置き換える素のダイアログ実装（issue #2203 Phase 2）。
// modal_controller.js と同様、document.getElementById(id) で対象パネルを引く方式。
// data-controller="drawer" は app/views/layouts/fronts.haml の <body> に付与。
//
// 使い方:
//   トリガー: data-action="click->drawer#show" data-drawer-id-param="foo-drawer"
//   閉じるボタン: data-action="click->drawer#hide" data-drawer-id-param="foo-drawer"
// モーダルが hidden クラスの着脱で開閉するのに対し、drawer は translate-y-full の着脱で
// 下から slide up するアニメーションを実現する（既存CSSの duration-200 と組み合わせて機能する）。
//
// modal_controller.js と同様の理由で、開いているパネルをスタックで管理する
// （単一の currentTarget だと、ネストして開いた場合に内側を閉じた時点で外側がまだ
// 開いているのに背景オーバーレイと body の overflow-hidden を消してしまう）。
// aria-hidden/aria-modal/role も Flowbite 同様に開閉と連動して着脱する。
export default class extends Controller {
  connect() {
    this.stack = []
    this.boundKeydown = this.onKeydown.bind(this)
    document.addEventListener('keydown', this.boundKeydown)
  }

  disconnect() {
    document.removeEventListener('keydown', this.boundKeydown)
    this.removeBackdrop()
  }

  show(event) {
    const target = document.getElementById(event.params.id)
    if (!target || this.stack.includes(target)) return
    this.stack.push(target)
    target.classList.remove('translate-y-full')
    target.removeAttribute('aria-hidden')
    target.setAttribute('aria-modal', 'true')
    target.setAttribute('role', 'dialog')
    document.body.classList.add('overflow-hidden')
    this.showBackdrop()
  }

  hide(event) {
    this.close(document.getElementById(event.params.id))
  }

  close(target) {
    if (!target) return
    target.classList.add('translate-y-full')
    target.setAttribute('aria-hidden', 'true')
    target.removeAttribute('aria-modal')
    target.removeAttribute('role')
    this.stack = this.stack.filter((t) => t !== target)
    if (this.stack.length === 0) {
      document.body.classList.remove('overflow-hidden')
      this.removeBackdrop()
    }
  }

  top() {
    return this.stack[this.stack.length - 1]
  }

  onKeydown(event) {
    if (event.key === 'Escape' && this.top()) {
      this.close(this.top())
    }
  }

  showBackdrop() {
    if (this.backdropEl) return
    const backdrop = document.createElement('div')
    backdrop.className = 'fixed inset-0 z-30 bg-gray-900/50'
    backdrop.addEventListener('click', () => this.close(this.top()))
    document.body.appendChild(backdrop)
    this.backdropEl = backdrop
  }

  removeBackdrop() {
    if (this.backdropEl) {
      this.backdropEl.remove()
      this.backdropEl = null
    }
  }
}
